<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div style="height: 100%">
                <div class="sa-card-list sa-flexbox-flex-direction-column">
                    <div class="sa-flexbox-column-content">
                        <b-row style="flex: 1">
                            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                <div class="sa-flexbox-column-content-main">
                                    <b-row @dragover.prevent @drop.self="onDrop(null)">
                                        <b-col v-for="(item, index) of listaAssistitiAssenti" :key="index" class="sa-card-list-col" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                            <div class="sa-card-list-container">
                                                <div v-if="item.regime === 'AMBULATORIALE'" class="sa-card-list-container-header">Regime Ambulatoriale</div>
                                                <div v-else class="sa-card-list-container-header">{{ item.denominazionePresidio }} - {{ item.nomeStanza }} - {{ item.nomeLetto }}</div>
                                                <div class="sa-card-list-container-body">
                                                    <div>
                                                        <img v-if="item.sesso === 'M'" src="@/assets/images/ico_m.png" />
                                                        <img v-else src="@/assets/images/ico_f.png" />
                                                    </div>
                                                    <div style="flex: 1; padding-left: 5px">
                                                        <span class="sa-card-list-container-body-row">
                                                            <b>{{ item.cognome + " " + item.nome }}</b>
                                                        </span>
                                                        <span class="sa-card-list-container-body-row">Data Nascita: {{ formatDate(item.dataNascita) }}</span>
                                                        <span class="sa-card-list-container-body-row">Da: </span>
                                                        <span class="sa-card-list-container-body-row">A: </span>
                                                    </div>
                                                </div>
                                                <div class="sa-card-list-container-footer text-right">
                                                    <b-button size="sm" v-b-tooltip.hover title="Segnala Ingresso" variant="outline-success outline-secondary-noborder pull-right" @click="onClickSegnalaIngresso(item)" class="mr-1 no-text"> <font-awesome-icon :icon="['fas', 'sign-in-alt']" /><br /> </b-button>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <rsa-registrazione-entrate-uscite-modal-edit-component ref="cmpRsaRegistrazioneEntrateUsciteModalEdit" @onSave="onSavePresenza" @onClose="onClosePresenza" />
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import CentroDiurnoMixin from "../mixins/CentroDiurnoMixin";
import RsaRegistrazioneEntrateUsciteModalEditComponent from "../../rsagestioneospiti/components/RsaRegistrazioneEntrateUsciteModalEditComponent.vue";
export default {
    mixins: [UtilityMixin, CentroDiurnoMixin],
    components: { RsaRegistrazioneEntrateUsciteModalEditComponent },
    data() {
        return {
            filtroAssenti: {},
        };
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.filtroAssenti = filtro;
            this.assistitiAssentiLoadData(me.filtroAssenti);
        },
        onClickSegnalaIngresso(item) {
            this.$refs.cmpRsaRegistrazioneEntrateUsciteModalEdit.show(item, "PRESENZA");
        },
        onSavePresenza() {
            let me = this;
            me.loadData(me.filtroAssenti);
        },
        onClosePresenza() {
            let me = this;
            me.loadData(me.filtroAssenti);
        },
    },
};
</script>

<style></style>
